/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

/**
 * Known form element types
 */
export enum FORM_EL_TYPE {
	SECTION_GROUP = "sectionGroup",
	SECTION = "section",
	ROW = "row",
	ROW_LIST = "rowList",
	FIELD_TEXT = "fieldText",
	FIELD_SELECT = "fieldSelect",
	FIELD_LABEL = "fieldLabel",
	HTML_CONTENT = "htmlContent",
	FORMULA = "formula",
	HIDDEN_EXPRESSION = "hiddenExpression"
}
